import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Qué formato tienen los recursos?',
  answer: 'Todos los recursos están en formato PDF de alta calidad, listos para imprimir o usar directamente en pantalla.'
}, {
  question: '¿Sirve para escuelas de Argentina?',
  answer: 'Sí, todo el material está alineado a los NAP (Núcleos de Aprendizaje Prioritarios) y los diseños curriculares vigentes en Argentina para 2026.'
}, {
  question: '¿Puedo usar el material en talleres privados?',
  answer: '¡Claro que sí! El material es ideal tanto para el aula formal como para clases particulares o talleres de ciencias.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Una vez realizado el pago, recibís un acceso inmediato a tu correo electrónico para descargar todo el contenido.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí, contás con una garantía de satisfacción de 7 días. Si el material no cumple con tus expectativas, te devolvemos el 100% de tu dinero.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-6 md:py-12 px-4 bg-sky-200/30" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black text-center text-slate-900 mb-6 md:mb-10" data-id="element-53">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-3" data-id="element-54">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-blue-100 overflow-hidden shadow-sm" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-5 md:p-6 text-left flex justify-between items-center gap-4" data-id="element-56">
                <span className="font-black text-slate-900 text-sm md:text-lg leading-tight" data-id="element-57">
                  {faq.question}
                </span>
                <div className="shrink-0 text-blue-600" data-id="element-58">
                  {openIndex === index ? <Minus size={20} data-id="element-59" /> : <Plus size={20} data-id="element-60" />}
                </div>
              </button>
              <AnimatePresence data-id="element-61">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-62">
                    <div className="px-5 md:px-6 pb-6 text-slate-600 font-medium text-xs md:text-base leading-relaxed" data-id="element-63">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}